// ui/web/src/hooks/useBuzzSession.ts
import { useBuzzSessionToken } from "@/shared/data/buzz"

export type BuzzConnectionStatus = "idle" | "loading" | "connected" | "error"

export interface UseBuzzSessionReturn {
  status: BuzzConnectionStatus
  sessionToken: string | null
  relayUrl: string | null
  error: Error | null
  refetch: () => void
}

/**
 * Manages the Buzz session token lifecycle.
 * Only fetches when buzzEnabled=true (user has opted in via Settings).
 */
export function useBuzzSession(buzzEnabled: boolean = false): UseBuzzSessionReturn {
  const { data, isLoading, isError, error, refetch } = useBuzzSessionToken({
    enabled: buzzEnabled,
  })

  const status: BuzzConnectionStatus = !buzzEnabled
    ? "idle"
    : isLoading
    ? "loading"
    : isError
    ? "error"
    : data?.token
    ? "connected"
    : "idle"

  return {
    status,
    sessionToken: data?.token ?? null,
    relayUrl: data?.relay_url ?? null,
    error: error as Error | null,
    refetch,
  }
}
